import styled from 'styled-components'

export const SwiperDiv = styled.div`
  width: 100%;
  padding-bottom: 0.25rem;
  align-items: flex-end;
`

export const IdeaEvaluationSwiperHeader = styled.div`
  display: flex;
  padding-bottom: 0.25rem;
  justify-content: center;
  align-items: center;
  color: var(--primary);
  text-decoration: none;
  font-size: 1rem;
  font-weight: bold;
`

export const IdeaEvaluationSwiperTitle = styled.div`
  max-width: 14rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const IdeaEvaluationSwiperSectionIndex = styled.div`
  display: flex;
  font-size: 14px;
  color: var(--primary);
  font-weight: bold;
  justify-content: center;
  margin-bottom: 0.5rem;
`

export const StickyHeaderWrapper = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: white;
  width: 100%;
`

export const SectionIndexContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.5rem;
  padding-bottom: 0.25rem;
  gap: 0.25rem;
`

export const IdeaEvaluationWrapper = styled.div`
  position: sticky;
  top: 80px;
  width: 100%;
  min-width: 0;
  height: calc(100vh - 80px);
  max-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  z-index: 2;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    display: contents;
    position: static;
    height: auto;
    max-height: none;
    overflow: visible;
  }
`

export const IdeaEvaluationHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 1.5rem 2rem 1rem 2rem;
  height: auto;
`

export const IdeaEvaluationTitle = styled.b`
  font-size: 28px;
  line-height: 48px;
`

export const IdeaEvaluationSubtitle = styled.span`
  font-weight: 600;
  font-size: 16px;
  margin-left: 4px;
  line-height: 19px;
`

export const IdeaEvaluationGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
`

export const IdeaEvaluationGroupBottom = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: end;
  padding: 1rem 0 0.5rem;
  gap: 1rem;
  width: 100%;
`

export const IdeaEvaluationGroupRightItem = styled.div`
  padding-left: 0;

  .total-items {
    margin-bottom: -4px;
  }
`

export const GeneralScoreTag = styled.div`
  background-color: #A0D6FF;
  color: #00477d;
  padding: 0;
  border-radius: 4px;
  display: flex;
  align-items: baseline;
  justify-content: center;
  height: auto;
  min-width: 88px;
  
  * {
    color: #00477d;
    font-weight: bold;
  }
`

export interface PointsProps {
  pointsFontSize: string
}

export const PointsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  height: 25px;
  width: 88px;
`

export const PointsDiv = styled.div<PointsProps>`
  font-size: ${(props) => props.pointsFontSize};
`

export const IdeaEvaluationSections = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 2rem 1.5rem;
  .swiper-button-next,
  .swiper-button-prev {
    color: var(--primary);
    top: 11px;
    width: 3rem;
    height: 3rem;
    font-weight: 800;
    &::after {
      font-size: 16px;
    }
  }
  @media screen and (max-width: 768px) {
      padding: 0rem 0.5rem; 
    }
`

export const FixedButtonGroup = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background-color: #ffffff;
  border-top: 1px solid #dee2e6;
  margin-top: auto;
  
  @media screen and (max-width: 768px) {
    padding: 1rem;
  }
`

export const SaveButtonStyled = styled.div`
  button {
    background-color: #ffffff !important;
    border: 1px solid var(--primary) !important;
    color: var(--primary) !important;
    
    &:hover:not(:disabled) {
      background-color: var(--primary-light) !important;
      border-color: var(--primary) !important;
      color: var(--primary) !important;
    }
    
    &:disabled {
      background-color: #ffffff !important;
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
`
